export default "__VITE_ASSET__DfKiq2Uc__"